import { formatDateLocal } from "../../helpers/timeline";

export const columnsDataDevelopment = [
  {
    Header: "No",
    accessor: "__index", // virtual accessor
  },
  {
    Header: "Judul",
    accessor: "subject",
  },
  
  {
    Header: "Deskripsi",
    accessor: "description",
  },
  {
    Header: "Created At",
    accessor: "created_at",
    Cell: (value) => formatDateLocal(value),
  },
  {
    Header: "Updated At",
    accessor: "updated_at",
    Cell: (value) => formatDateLocal(value),
  },
];
